export default "__VITE_ASSET__DsdQE6sl__"